// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEnumInfoDto
 */
export interface IEnumInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IEnumInfoDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEnumInfoDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEnumInfoDto
     */
    description?: string;
}

/**
 * Check if a given object implements the IEnumInfoDto interface.
 */
export function instanceOfIEnumInfoDto(value: object): value is IEnumInfoDto {
    return true;
}

export function IEnumInfoDtoFromJSON(json: any): IEnumInfoDto {
    return IEnumInfoDtoFromJSONTyped(json, false);
}

export function IEnumInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEnumInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function IEnumInfoDtoToJSON(json: any): IEnumInfoDto {
    return IEnumInfoDtoToJSONTyped(json, false);
}

export function IEnumInfoDtoToJSONTyped(value?: IEnumInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
    };
}

